import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConvertWithDecimalPipe } from './convertWithDecimal.pipe';
import { IntialsNamePipe } from './intials-name.pipe';
import { TimeagoPipe } from './timeago.pipe';
import {
  MemberFullNamePipe,
  MemberInitialsPipe,
  PermissionLabelPipe,
  RoleLabelPipe,
} from '../../pages/team/team-member.pipes';
import { ActivityCategoryLabelPipe } from '../../pages/team/activity.pipes';

@NgModule({
  declarations: [
    ConvertWithDecimalPipe,
    IntialsNamePipe,
    TimeagoPipe,
    MemberFullNamePipe,
    MemberInitialsPipe,
    PermissionLabelPipe,
    RoleLabelPipe,
    ActivityCategoryLabelPipe,
  ],
  imports: [CommonModule],
  exports: [
    ConvertWithDecimalPipe,
    IntialsNamePipe,
    TimeagoPipe,
    MemberFullNamePipe,
    MemberInitialsPipe,
    PermissionLabelPipe,
    RoleLabelPipe,
    ActivityCategoryLabelPipe,
  ],
})
export class PipesModule {}
